var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup406(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 212,
    viewBox: "0 0 242 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0993652,
    y: 0.730835,
    width: 241.801,
    height: 210.845,
    rx: 20,
    fill: "#CACACA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_165_111)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.5334,
    y: 13.8684,
    width: 212.933,
    height: 185.672,
    rx: 20,
    fill: "#E4E4E4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.927 83.0137H97.3089V35.6316H49.927V83.0137ZM56.6959 76.2447H90.5401V42.4006H56.6959V76.2447Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.154 69.476H137.922V35.6316H117.616V42.4006H104.078V49.1693H117.616V55.9383H131.154V69.476ZM124.385 49.1693H131.154V42.4006H124.385V49.1693Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.691 83.0137H192.073V35.6316H144.691V83.0137ZM151.46 76.2447H185.305V42.4006H151.46V76.2447Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4651 69.476H70.2338H77.0028H83.7715V62.707V55.9383V49.1693H77.0028H70.2338H63.4651V55.9383V62.707V69.476Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.229 69.476H164.998H171.767H178.536V62.707V55.9383V49.1693H171.767H164.998H158.229V55.9383V62.707V69.476Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.847 69.476H117.616V62.707V55.9383H110.847H104.078V62.707H110.847V69.476Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.078 83.0137H110.847V76.2447V69.476H104.078V76.2447V83.0137Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.385 76.2447H131.154V69.476H124.385",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.615 83.0137H124.384V76.2448H117.615",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.153 83.0137H137.922V76.2448H131.153",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.846 89.7825H117.615V83.0137H110.846",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6961 123.627H63.465H70.2337V116.858H77.0027V123.627H83.7714V116.858V110.089H77.0027V103.32H70.2337V96.5514H77.0027V103.32H83.7714V110.089H90.5404H97.3091H104.078H110.847V103.32H104.078H97.3091H90.5404V96.5514H83.7714V89.7825H77.0027H70.2337H63.465H56.6961H49.9272V96.5514H56.6961H63.465V103.32H56.6961H49.9272V110.089V116.858H56.6961V123.627Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5403 96.5514H97.309H104.078H110.847V89.7825H104.078H97.309H90.5403V96.5514Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.078 137.165H110.847V123.627H124.384V116.858H131.153V130.396H137.922V116.858H151.46V130.396H158.229V89.7825H151.46V96.5514H144.691V89.7825H137.922V96.5514H131.153V89.7825H124.384V103.32H131.153V110.089H124.384V103.32H117.616V110.089H110.847V116.858H90.5403V123.627H104.078V137.165ZM137.922 110.089H144.691V103.32H137.922V110.089Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.998 116.858H171.767V110.089V103.32H178.535V96.5514H171.767V89.7825H164.998V96.5514V103.32V110.089V116.858Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.535 96.5514H185.304V89.7825H178.535",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.535 116.858H185.304H192.073V110.089H185.304V103.32H178.535V110.089V116.858Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.304 137.165H192.073V130.396V123.627H185.304V130.396V137.165Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9272 177.778H97.3091V130.396H49.9272V177.778ZM56.6961 171.009H90.5404V137.165H56.6961V171.009Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.078 177.778H110.847V164.24H117.616V157.471H110.847V150.702H117.616V157.471H131.154V164.24H117.616V177.778H124.385V171.009H131.154V177.778H137.922V171.009H151.46V177.778H178.535V164.24H171.767V157.471H178.535V150.702H185.304V143.933H178.535V130.396H164.998V143.933H158.229V157.471H164.998V164.24H158.229V157.471H151.46V150.702H144.691V143.933H137.922V150.702H131.154V143.933H124.385V137.165H131.154V130.396H117.616V137.165H110.847V143.933H104.078V177.778ZM137.922 164.24H144.691V157.471H137.922V164.24Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.922 137.165H144.691V130.396H137.922",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.46 143.933H158.229V137.165H151.46",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4651 164.24H70.2338H77.0028H83.7715V157.471V150.702V143.933H77.0028H70.2338H63.4651V150.702V157.471V164.24Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.304 171.009H192.073V164.24H185.304",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_165_111",
    x: 8.53345,
    y: 7.86841,
    width: 224.933,
    height: 197.672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_165_111"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_165_111"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_165_111",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup406);
export default __webpack_public_path__ + "static/media/Group406.da41ce3142b057c1a2cf85eb1399c645.svg";
export { ForwardRef as ReactComponent };